module.exports = __webpack_public_path__ + "static/img/home_service_images_40_h5_zh.aec66cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_service_images_40_h5_zh.png
// module id = +jEL
// module chunks = 34